import apiClient from './client';

// Cost Centers
export const getCostCenters = async (params = {}) => {
  const response = await apiClient.get('/erp/cost-centers', { params });
  return response.data;
};

export const createCostCenter = async (data) => {
  const response = await apiClient.post('/erp/cost-centers', data);
  return response.data;
};

// Fixed Assets
export const getFixedAssets = async (params = {}) => {
  const response = await apiClient.get('/erp/fixed-assets', { params });
  return response.data;
};

export const createFixedAsset = async (data) => {
  const response = await apiClient.post('/erp/fixed-assets', data);
  return response.data;
};

// Bank Reconciliation
export const getReconciliations = async () => {
  const response = await apiClient.get('/erp/reconciliations');
  return response.data;
};

export const createReconciliation = async (data) => {
  const response = await apiClient.post('/erp/reconciliations', data);
  return response.data;
};
